const data = [
  {
    kayitNo: 5324989,
    tarih: '2024-10-15',
    gonderenAdi: 'ERTAŞ AMBALAJ VE BASKI SAN. TİC. LTD. ŞTİ.',
    stokAdi: 'TORBA',
    depo: 34,
    aracNo: 20240495,
    fisNo: 1618131,
    kapSayisi: 2,
    kg: 1183,
    m3: 3.0965,
    miktar: 96200,
    sevkTarihi: '2024-10-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5297154,
    tarih: '2024-09-13',
    gonderenAdi: 'MERT TEKS.MAHMUT ERYİĞİT',
    stokAdi: 'KUMAŞ',
    depo: 34,
    aracNo: 20240407,
    fisNo: 1611254,
    kapSayisi: 1,
    kg: 27,
    m3: 0.06,
    miktar: 100,
    sevkTarihi: '2024-09-13',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5296424,
    tarih: '2024-09-11',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240401,
    fisNo: 1611076,
    kapSayisi: 1,
    kg: 2,
    m3: 0.024,
    miktar: 1,
    sevkTarihi: '2024-09-11',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5295094,
    tarih: '2024-09-09',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240398,
    fisNo: 1610661,
    kapSayisi: 1,
    kg: 15,
    m3: 0.012,
    miktar: 1,
    sevkTarihi: '2024-09-09',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5290882,
    tarih: '2024-08-31',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'ELBİSE',
    depo: 34,
    aracNo: 20240385,
    fisNo: 1609793,
    kapSayisi: 1,
    kg: 28,
    m3: 0.1125,
    miktar: 60,
    sevkTarihi: '2024-08-31',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5288366,
    tarih: '2024-08-26',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'ELBİSE',
    depo: 34,
    aracNo: 20240377,
    fisNo: 1609126,
    kapSayisi: 3,
    kg: 99,
    m3: 0.44999999999999996,
    miktar: 150,
    sevkTarihi: '2024-08-27',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5284418,
    tarih: '2024-08-16',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'ELBİSE',
    depo: 34,
    aracNo: 20240364,
    fisNo: 1608223,
    kapSayisi: 1,
    kg: 26,
    m3: 0.192,
    miktar: 50,
    sevkTarihi: '2024-08-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5281538,
    tarih: '2024-08-13',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240355,
    fisNo: 1607855,
    kapSayisi: 1,
    kg: 10,
    m3: 0.03,
    miktar: 1,
    sevkTarihi: '2024-08-12',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5280062,
    tarih: '2024-08-09',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240351,
    fisNo: 1607482,
    kapSayisi: 1,
    kg: 28,
    m3: 0.17,
    miktar: 1,
    sevkTarihi: '2024-08-09',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5275102,
    tarih: '2024-07-29',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'ELBİSE',
    depo: 34,
    aracNo: 20240338,
    fisNo: 1606371,
    kapSayisi: 1,
    kg: 27,
    m3: 0.13125,
    miktar: 30,
    sevkTarihi: '2024-07-29',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5274760,
    tarih: '2024-07-27',
    gonderenAdi: 'SÖKTAŞ TEKSTİL SAN.VE TİC.A.Ş ',
    stokAdi: 'KUMAŞ',
    depo: 27,
    aracNo: 20240337,
    fisNo: 1606326,
    kapSayisi: 1,
    kg: 1,
    m3: 0.01,
    miktar: 2,
    sevkTarihi: '2024-07-30',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5272362,
    tarih: '2024-07-23',
    gonderenAdi: 'GÜMAN İNŞ.ÇİÇ.OTO.SAB.VE DAY.TÜL.MAL.PAZ.TİC.LTD.Ş',
    stokAdi: 'YAPAY ÇİÇEK',
    depo: 34,
    aracNo: 20240330,
    fisNo: 1605864,
    kapSayisi: 8,
    kg: 112,
    m3: 1.84,
    miktar: 8,
    sevkTarihi: '2024-07-23',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5268333,
    tarih: '2024-07-15',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240320,
    fisNo: 1605225,
    kapSayisi: 2,
    kg: 28,
    m3: 0.3795,
    miktar: 2,
    sevkTarihi: '2024-07-15',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5265721,
    tarih: '2024-07-08',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240312,
    fisNo: 1604641,
    kapSayisi: 1,
    kg: 2,
    m3: 0.012,
    miktar: 1,
    sevkTarihi: '2024-07-08',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5256209,
    tarih: '2024-06-08',
    gonderenAdi: 'GÜLER PLASTK.PRO.ÜRÜNL.TEKS.DIŞ TİC.LTD.ŞTİ.',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240290,
    fisNo: 1602891,
    kapSayisi: 1,
    kg: 5,
    m3: 0.0175,
    miktar: 1,
    sevkTarihi: '2024-06-11',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5256189,
    tarih: '2024-06-08',
    gonderenAdi: 'GÜLER PLASTK.PRO.ÜRÜNL.TEKS.DIŞ TİC.LTD.ŞTİ.',
    stokAdi: 'KARTELA',
    depo: 34,
    aracNo: 20240290,
    fisNo: 1602890,
    kapSayisi: 20,
    kg: 420,
    m3: 1.4699999999999993,
    miktar: 2500,
    sevkTarihi: '2024-06-11',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5248334,
    tarih: '2024-05-28',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'KUMAŞ',
    depo: 34,
    aracNo: 20240265,
    fisNo: 1600953,
    kapSayisi: 1,
    kg: 7,
    m3: 0.014,
    miktar: 25,
    sevkTarihi: '2024-05-28',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5247893,
    tarih: '2024-05-27',
    gonderenAdi: 'SÖKTAŞ TEKSTİL SANAYİ TİC.A.Ş',
    stokAdi: 'KUMAŞ',
    depo: 34,
    aracNo: 20240265,
    fisNo: 1600788,
    kapSayisi: 1,
    kg: 3,
    m3: 0.001,
    miktar: 2.6,
    sevkTarihi: '2024-05-28',
    musteriKodu: 'E-0333',
    birim: 'KG'
  },
  {
    kayitNo: 5238841,
    tarih: '2024-05-17',
    gonderenAdi: 'EGELİ HAVUZ SAN. VE TİC. LTD. ŞTİ. ',
    stokAdi: 'HAVUZ ROBOTU',
    depo: 34,
    aracNo: 20240241,
    fisNo: 1598362,
    kapSayisi: 4,
    kg: 44,
    m3: 0.18719999999999998,
    miktar: 4,
    sevkTarihi: '2024-05-17',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5238065,
    tarih: '2024-05-16',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240239,
    fisNo: 1598024,
    kapSayisi: 2,
    kg: 4,
    m3: 0.027,
    miktar: 2,
    sevkTarihi: '2024-05-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5237736,
    tarih: '2024-05-16',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240239,
    fisNo: 1597868,
    kapSayisi: 1,
    kg: 12,
    m3: 0.025,
    miktar: 10,
    sevkTarihi: '2024-05-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5237077,
    tarih: '2024-05-15',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240236,
    fisNo: 1597582,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-05-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5236950,
    tarih: '2024-05-15',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240239,
    fisNo: 1597530,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-05-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5236949,
    tarih: '2024-05-15',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240236,
    fisNo: 1597530,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-05-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5236948,
    tarih: '2024-05-15',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240234,
    fisNo: 1597530,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-05-15',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5236626,
    tarih: '2024-05-14',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240234,
    fisNo: 1597375,
    kapSayisi: 1,
    kg: 7,
    m3: 0.055125,
    miktar: 1,
    sevkTarihi: '2024-05-15',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5235806,
    tarih: '2024-05-13',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240231,
    fisNo: 1597086,
    kapSayisi: 1,
    kg: 8,
    m3: 0.0027,
    miktar: 1,
    sevkTarihi: '2024-05-14',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5235805,
    tarih: '2024-05-13',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240233,
    fisNo: 1597086,
    kapSayisi: 1,
    kg: 8,
    m3: 0.0027,
    miktar: 1,
    sevkTarihi: '2024-05-14',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5235802,
    tarih: '2024-05-13',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240230,
    fisNo: 1597081,
    kapSayisi: 3,
    kg: 24,
    m3: 0.081,
    miktar: 3,
    sevkTarihi: '2024-05-13',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5233025,
    tarih: '2024-05-09',
    gonderenAdi: 'MERT TEKS.MAHMUT ERYİĞİT',
    stokAdi: 'KUMAŞ',
    depo: 35,
    aracNo: 20240223,
    fisNo: 1596228,
    kapSayisi: 1,
    kg: 51,
    m3: 0.09375,
    miktar: 270,
    sevkTarihi: '2024-05-09',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5233023,
    tarih: '2024-05-09',
    gonderenAdi: 'MERT TEKS.MAHMUT ERYİĞİT',
    stokAdi: 'KUMAŞ',
    depo: 35,
    aracNo: 20240222,
    fisNo: 1596228,
    kapSayisi: 2,
    kg: 102,
    m3: 0.2925,
    miktar: 536,
    sevkTarihi: '2024-05-09',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5232742,
    tarih: '2024-05-08',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240220,
    fisNo: 1596136,
    kapSayisi: 1,
    kg: 1,
    m3: 0.015,
    miktar: 1,
    sevkTarihi: '2024-05-08',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5231991,
    tarih: '2024-05-08',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240219,
    fisNo: 1595884,
    kapSayisi: 1,
    kg: 10,
    m3: 0.024,
    miktar: 1,
    sevkTarihi: '2024-05-08',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5220184,
    tarih: '2024-04-17',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 27,
    aracNo: 20240187,
    fisNo: 1592345,
    kapSayisi: 1,
    kg: 1,
    m3: 0.01,
    miktar: 1,
    sevkTarihi: '2024-04-18',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5219617,
    tarih: '2024-04-16',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240184,
    fisNo: 1592162,
    kapSayisi: 1,
    kg: 1,
    m3: 0.012,
    miktar: 1,
    sevkTarihi: '2024-04-15',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5219016,
    tarih: '2024-04-05',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240182,
    fisNo: 1591963,
    kapSayisi: 1,
    kg: 5,
    m3: 0.006,
    miktar: 1,
    sevkTarihi: '2024-04-05',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5214742,
    tarih: '2024-03-27',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240168,
    fisNo: 1590764,
    kapSayisi: 1,
    kg: 1,
    m3: 0.001,
    miktar: 1,
    sevkTarihi: '2024-03-27',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5200699,
    tarih: '2024-03-12',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240134,
    fisNo: 1587323,
    kapSayisi: 1,
    kg: 1,
    m3: 0.001,
    miktar: 1,
    sevkTarihi: '2024-03-13',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5197207,
    tarih: '2024-03-08',
    gonderenAdi: 'BİLLUR DEK.DÖK.AYD.SAN.VE DIŞ.TİC.',
    stokAdi: 'AYDINLATMA MLZ. (LED)',
    depo: 34,
    aracNo: 20240126,
    fisNo: 1586227,
    kapSayisi: 2,
    kg: 13,
    m3: 0.4615,
    miktar: 8,
    sevkTarihi: '2024-03-08',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5175086,
    tarih: '2024-02-16',
    gonderenAdi: 'METEBRONZ MOB.AKSESUAR SAN.TİC.A.Ş.',
    stokAdi: 'ABAJUR',
    depo: 34,
    aracNo: 20240063,
    fisNo: 1579537,
    kapSayisi: 139,
    kg: 1248,
    m3: 21.000138000000046,
    miktar: 36.00000000000006,
    sevkTarihi: '2024-02-14',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5173431,
    tarih: '2024-02-13',
    gonderenAdi: 'GÜLER PLASTK.PRO.ÜRÜNL.TEKS.DIŞ TİC.LTD.ŞTİ.',
    stokAdi: 'KATALOG',
    depo: 34,
    aracNo: 20240069,
    fisNo: 1579073,
    kapSayisi: 4,
    kg: 105,
    m3: 0.29100000000000004,
    miktar: 10500,
    sevkTarihi: '2024-02-16',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5168094,
    tarih: '2024-02-01',
    gonderenAdi: 'SÖKTAŞ TEKSTİL SAN.VE TİC.A.Ş ',
    stokAdi: 'KUMAŞ',
    depo: 27,
    aracNo: 20240045,
    fisNo: 1577462,
    kapSayisi: 1,
    kg: 1,
    m3: 0.05,
    miktar: 8,
    sevkTarihi: '2024-02-01',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5167062,
    tarih: '2024-01-30',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 27,
    aracNo: 20240042,
    fisNo: 1577195,
    kapSayisi: 1,
    kg: 5,
    m3: 0.1,
    miktar: 1,
    sevkTarihi: '2024-01-31',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5163479,
    tarih: '2024-01-25',
    gonderenAdi: 'ODAK MOBİLYA DEKORASYON SAN.VE TİC.LTD.ŞTİ.',
    stokAdi: 'BERJER',
    depo: 34,
    aracNo: 20240038,
    fisNo: 1576850,
    kapSayisi: 17,
    kg: 555,
    m3: 9.928634999999995,
    miktar: 23,
    sevkTarihi: '2024-01-26',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5162152,
    tarih: '2024-01-24',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240035,
    fisNo: 1576719,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-01-24',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5162151,
    tarih: '2024-01-24',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240035,
    fisNo: 1576718,
    kapSayisi: 1,
    kg: 3,
    m3: 0.018,
    miktar: 1,
    sevkTarihi: '2024-01-24',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5162150,
    tarih: '2024-01-24',
    gonderenAdi: 'TATEKS TEKS.TUR.SAN.TİC.LTD.ŞTİ',
    stokAdi: 'TELA',
    depo: 34,
    aracNo: 20240035,
    fisNo: 1576717,
    kapSayisi: 1,
    kg: 2,
    m3: 0.0315,
    miktar: 20,
    sevkTarihi: '2024-01-24',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5162029,
    tarih: '2024-01-24',
    gonderenAdi: 'MERT TEKS.MAHMUT ERYİĞİT',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240038,
    fisNo: 1576687,
    kapSayisi: 1,
    kg: 20,
    m3: 0.096,
    miktar: 1,
    sevkTarihi: '2024-01-26',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5162027,
    tarih: '2024-01-24',
    gonderenAdi: 'MERT TEKS.MAHMUT ERYİĞİT',
    stokAdi: 'KUMAŞ',
    depo: 34,
    aracNo: 20240035,
    fisNo: 1576686,
    kapSayisi: 2,
    kg: 90,
    m3: 0.28,
    miktar: 250,
    sevkTarihi: '2024-01-24',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5161324,
    tarih: '2024-01-23',
    gonderenAdi: 'ÇELİKLER BEYAZ EŞYA ELEKTR.MOB.TİC.SAN.LTD.ŞTİ.',
    stokAdi: 'BERJER',
    depo: 34,
    aracNo: 20240033,
    fisNo: 1576572,
    kapSayisi: 29,
    kg: 793,
    m3: 13.694020999999983,
    miktar: 27,
    sevkTarihi: '2024-01-23',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5161251,
    tarih: '2024-01-23',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240031,
    fisNo: 1576548,
    kapSayisi: 1,
    kg: 5,
    m3: 0.001,
    miktar: 1,
    sevkTarihi: '2024-01-22',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5161250,
    tarih: '2024-01-23',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240031,
    fisNo: 1576547,
    kapSayisi: 1,
    kg: 1,
    m3: 0.008,
    miktar: 1,
    sevkTarihi: '2024-01-22',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5161246,
    tarih: '2024-01-23',
    gonderenAdi: 'KENDİSİ',
    stokAdi: 'MUTFAK EŞYASI',
    depo: 27,
    aracNo: 20240032,
    fisNo: 1576544,
    kapSayisi: 2,
    kg: 20,
    m3: 0.25,
    miktar: 20,
    sevkTarihi: '2024-01-23',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5160145,
    tarih: '2024-01-19',
    gonderenAdi: 'GÜNEY ÇELİK KASALARI ALİ KOŞAN',
    stokAdi: 'ÇELİK KASA',
    depo: 27,
    aracNo: 20240029,
    fisNo: 1576316,
    kapSayisi: 2,
    kg: 470,
    m3: 0.7,
    miktar: 2,
    sevkTarihi: '2024-01-20',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5157299,
    tarih: '2024-01-12',
    gonderenAdi: 'SERALİFE YAPI ÜRÜNLERİ A.Ş.',
    stokAdi: 'KÜVET',
    depo: 34,
    aracNo: 20240021,
    fisNo: 1575737,
    kapSayisi: 2,
    kg: 100,
    m3: 3.23,
    miktar: 2,
    sevkTarihi: '2024-01-12',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5157078,
    tarih: '2024-01-12',
    gonderenAdi: 'BRONZ HALI SANAYİ VE TİC AŞ',
    stokAdi: 'MAKİNA HALISI',
    depo: 34,
    aracNo: 20240017,
    fisNo: 1575691,
    kapSayisi: 1,
    kg: 24,
    m3: 0.1875,
    miktar: 1,
    sevkTarihi: '2024-01-11',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5156864,
    tarih: '2024-01-11',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'NUMUNE',
    depo: 34,
    aracNo: 20240018,
    fisNo: 1575625,
    kapSayisi: 2,
    kg: 10,
    m3: 0.0525,
    miktar: 2,
    sevkTarihi: '2024-01-11',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5155756,
    tarih: '2024-01-09',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'KUMAŞ',
    depo: 34,
    aracNo: 20240012,
    fisNo: 1575344,
    kapSayisi: 1,
    kg: 1,
    m3: 0.006,
    miktar: 10,
    sevkTarihi: '2024-01-08',
    musteriKodu: 'E-0333',
    birim: 'MT'
  },
  {
    kayitNo: 5154851,
    tarih: '2024-01-06',
    gonderenAdi: 'FUAT ABDULAZİZOĞLU',
    stokAdi: 'ARMATÜR',
    depo: 34,
    aracNo: 20240010,
    fisNo: 1575119,
    kapSayisi: 9,
    kg: 92,
    m3: 0.7439999999999999,
    miktar: 20,
    sevkTarihi: '2024-01-06',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5154705,
    tarih: '2024-01-05',
    gonderenAdi: 'SERALİFE YAPI ÜRÜNLERİ A.Ş.',
    stokAdi: 'AYNA',
    depo: 34,
    aracNo: 20240008,
    fisNo: 1575072,
    kapSayisi: 18,
    kg: 578,
    m3: 3.488999400000001,
    miktar: 13,
    sevkTarihi: '2024-01-05',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  },
  {
    kayitNo: 5153106,
    tarih: '2024-01-03',
    gonderenAdi: 'ALTUNTUR DEPO',
    stokAdi: 'ŞAHSİ EŞYA',
    depo: 34,
    aracNo: 20240004,
    fisNo: 1574819,
    kapSayisi: 2,
    kg: 22,
    m3: 0.2125,
    miktar: 30,
    sevkTarihi: '2024-01-03',
    musteriKodu: 'E-0333',
    birim: 'ADET'
  }
];

export default data;
